import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["valueType", "fieldContainer"]
  static values = { currentType: String }

  connect() {
    this.updateFieldVisibility()
  }

  valueTypeChanged() {
    this.currentTypeValue = this.valueTypeTarget.value
    this.updateFieldVisibility()
  }

  updateFieldVisibility() {
    const selectedType = this.valueTypeTarget.value
    
    // Masquer tous les conteneurs de champs et désactiver leurs inputs.
    // lexxy-editor (champ riche) est un form-associated custom element : seul
    // l'ATTRIBUT disabled l'exclut de la soumission (la propriété JS n'a aucun
    // effet sur un custom element) — on pose donc l'attribut pour tous.
    this.fieldContainerTargets.forEach(container => {
      container.classList.add('hidden')
      const inputs = container.querySelectorAll('input, textarea, select, lexxy-editor')
      inputs.forEach(input => {
        input.setAttribute('disabled', '')
      })
    })

    // Afficher le conteneur correspondant au type sélectionné et activer ses inputs
    if (selectedType) {
      const targetContainer = this.element.querySelector(`[data-field-type="${selectedType}"]`)
      if (targetContainer) {
        targetContainer.classList.remove('hidden')
        // Activer tous les inputs dans ce conteneur (attribut, cf. ci-dessus)
        const inputs = targetContainer.querySelectorAll('input, textarea, select, lexxy-editor')
        inputs.forEach(input => {
          input.removeAttribute('disabled')
        })
      }
    }
  }
} 